module.exports = __webpack_public_path__ + "img/clipboards.f87b2267.svg";